import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SpellCheckerState {
    activated: boolean;
    errors: any[];
}


const initialState: SpellCheckerState = {
    activated: false,
    errors: []
}

const spellcheckerSlice = createSlice({
    name: 'spellchecker',
    initialState,
    reducers: {
        spellcheckerActivate: (state, action: PayloadAction<boolean>) => {
            state.activated = action.payload;
        },
        spellcheckerSetErrors: (state, action: PayloadAction<any[]>) => {
            state.errors = action.payload;
        },
        spellcheckerRemoveErrors: (state, action: PayloadAction<number>) => {
            state.errors.splice(action.payload, 1);
        },

    }
})

export const { spellcheckerActivate, spellcheckerSetErrors, spellcheckerRemoveErrors } = spellcheckerSlice.actions;

export default spellcheckerSlice.reducer;